var currentLanguage =  'he';
var currentDashboard =  'simple';  // 'qmobile';

if (window.location.host.indexOf('qmobile') > -1){
    currentDashboard = 'qmobile';
}

if (window.location.host.indexOf('allsim') > -1){
    currentDashboard = 'allsim';
}

if (window.location.host.indexOf('all-sim') > -1){
    currentDashboard = 'all-sim';
}

if (window.location.host.indexOf('tenecom') > -1){
    currentDashboard = 'tenecom';
}

if (window.location.host.indexOf('onestop') > -1){
    currentDashboard = 'onestop';
}

var languages = [];
var cities;
var streets;
var banks;

loadLanguage(currentLanguage);
loadCities();
loadStreets();
loadBanks();

function loadLanguage(language){
    languages[language] = require('./' + language + ".json");
}

function loadCities(){
    cities = require('../cities_streets/cities_only.json');
}

function loadStreets(){
    streets = require('../cities_streets/street_cities.json');
}

function loadBanks(){
    banks = require('../banks.json');
}

export function getCurrentTextResource() {
    return languages[currentLanguage];
}

export function getCurrentDashboard() {
    return currentDashboard;
}

export function getAllCities(){
    return cities;
}

export function getAllStreets(){
    return streets;
}

export function getBanks(){
    return banks;
}

